module.exports = __webpack_public_path__ + "static/img/content.5273b57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/content.png
// module id = 5WG7
// module chunks = 1